import React from 'react';
import * as Styles from './IconThumbsUp.styles';

const IconThumbsUp = ({
  testId = 'IconThumbsUp',
  selected,
}) => (
  <Styles.Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testId}
  >
    <g clipPath="url(#clip0_439_7446)">
      <path d="M4.66671 14.6667V7.33334M1.33337 8.66667V13.3333C1.33337 14.0697 1.93033 14.6667 2.66671 14.6667H11.6175C12.6047 14.6667 13.4442 13.9465 13.5943 12.9708L14.3122 8.30414C14.4986 7.0926 13.5612 6 12.3355 6H10C9.63184 6 9.33337 5.70152 9.33337 5.33334V2.97723C9.33337 2.06933 8.59737 1.33334 7.68951 1.33334C7.47291 1.33334 7.27671 1.46087 7.18877 1.65875L4.84267 6.9374C4.73567 7.1782 4.49692 7.33334 4.23346 7.33334H2.66671C1.93033 7.33334 1.33337 7.93027 1.33337 8.66667Z" stroke={selected ? '#0070D1' : '#4A4A4A'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_439_7446">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </Styles.Svg>
);

export default IconThumbsUp;
